import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const showOrderPopupAction = (): FluxStandardAction => {
    return {
        type: Actions.SHOW_PENDING_ORDER_POPUP,
    }
};

export const hideOrderPopupAction = (): FluxStandardAction => {
    return {
        type: Actions.HIDE_PENDING_ORDER_POPUP,
    }
};
export const setPaymentUrl = (url?: string): FluxStandardAction => {
    return {
        type: Actions.SET_PAYMENT_URL,
        payload: url
    }
};

export const setOrderDetailsList = (orderDetails?: any): FluxStandardAction => {
    return {
        type: Actions.SET_PAYMENT_URL,
        payload: orderDetails
    }
};
